import { SharedStoreSlices } from './shared.slices';
import { VloketStoreSlice } from './v-loket.slices';

export const StoreSlice = Object.freeze({
	...SharedStoreSlices,
	...VloketStoreSlice
});
